import { AnalyticsProvider } from './AnalyticsProvider';

export class MockProvider extends AnalyticsProvider {
  init(): void {}

  public get name(): string { return 'Mock'; }

  authorize(): void {}

  reset(): void {}

  trackEvent = jest.fn();

  trackPageVisit = jest.fn();

  get initialized(): boolean {
    return true;
  }

  mapAndExtendProperties = jest.fn();
}
